import { AuctionLotModel } from "./auction-lot.model";
import { RemittanceModel } from "./remittance.model";

export class RemittanceItemModel {
    RemittanceId: number;
    AuctionLotId: number;

    HammerPrice: number;
    PremiumIncGST: number;
    GSTPremium: number;
    TotalHammer: number;
    TotalHammerInclGST: number;
    GSTTotalHammer: number;
    LotPremium: number;

    AuctionLot: AuctionLotModel;
    Remittance: RemittanceModel;
}